import { NgModule } from '@angular/core';
import { TypeaheadIeFixDirective } from './typeahead-ie-fix.directive';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';

@NgModule({
  declarations: [TypeaheadIeFixDirective],
  imports: [
    TypeaheadModule,
  ],
  exports:[
    TypeaheadIeFixDirective,
    TypeaheadModule,
  ],
})
export class TypeaheadIeFixModule { 
  static forRoot() {
    return {
      ngModule:TypeaheadIeFixModule,
      providers:[...TypeaheadModule.forRoot().providers]
    }
  }
}
